import { all } from 'redux-saga/effects'
import { facebookSagas } from './facebook/facebook.sagas'

// Add explicit Generator type to avoid TypeScript trying to infer complex return type
export function * facebookSettingsRootSagas (): Generator<any, any, any> {
  yield all([
    facebookSagas(),
  ])
}
